import { FeaturesSection } from "./components/features-section.tsx";
import { FinalCtaSection } from "./components/final-cta-section.tsx";
import { GettingStartedSection } from "./components/getting-started-section.tsx";
import { HeroSection } from "./components/hero-section.tsx";
import { LandingFooter } from "./components/landing-footer.tsx";
import { StocksSection } from "./components/stocks-section.tsx";
import { LandingNav } from "./components/landing-nav.tsx";
import { pageBgStyle } from "./components/landing-styles";

// Landing is dark-mode only — the `dark` class on <main> below scopes it.
// App tokens are re-declared under `.dark` in styles.css so this nested scope
// resolves to the dark palette (no JS, no theme-store race).
function LandingPage() {
	return (
		<main
			className="dark relative isolate min-h-screen overflow-clip bg-background text-foreground"
			style={pageBgStyle}
		>
			{/* Film grain texture — replaces grid overlay */}
			<svg
				className="pointer-events-none absolute inset-0 h-full w-full"
				aria-hidden="true"
				style={{
					opacity: "var(--opacity-5)",
					maskImage:
						"linear-gradient(180deg, black 0%, rgb(0 0 0 / var(--opacity-61)) 70%, transparent 100%)",
				}}
			>
				<filter id="landing-grain">
					<feTurbulence
						type="fractalNoise"
						baseFrequency="0.72"
						numOctaves="4"
						stitchTiles="stitch"
					/>
					<feColorMatrix type="saturate" values="0" />
				</filter>
				<rect width="100%" height="100%" filter="url(#landing-grain)" />
			</svg>

			<LandingNav />
			<div className="mx-auto w-[calc(100%-16px)] max-w-345 pb-12 md:w-[calc(100%-24px)] lg:w-[calc(100%-48px)] pt-2">
				<HeroSection />
				<StocksSection />
				<FeaturesSection />
				<GettingStartedSection />
				<FinalCtaSection />
				<LandingFooter />
			</div>
		</main>
	);
}

export default LandingPage;
